import { apiClient } from "../../../lib/apiClient";
import type { ApiResponse } from "../../../types/apiResponse";
import type { ClientData } from "../types";

export const fetchClientById = async (id: number): Promise<ApiResponse<ClientData>> => {
  return await apiClient<ApiResponse<ClientData>>(`/v1/client/${id}`);
};
